export enum SpecificCutOffFlag {
  Normal = 1,
  Abnormal = 2,
  Indeterminate = 4,
  None = 8,
}
